import { context, metrics, propagation } from "@opentelemetry/api"
import { logs } from "@opentelemetry/api-logs"
import { W3CTraceContextPropagator } from "@opentelemetry/core"
import { ZoneContextManager } from "@opentelemetry/context-zone"
import { OTLPLogExporter } from "@opentelemetry/exporter-logs-otlp-http"
import { OTLPMetricExporter } from "@opentelemetry/exporter-metrics-otlp-http"
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http"
import { Resource } from "@opentelemetry/resources"
import { BatchLogRecordProcessor, LoggerProvider } from "@opentelemetry/sdk-logs"
import { MeterProvider, PeriodicExportingMetricReader } from "@opentelemetry/sdk-metrics"
import { BatchSpanProcessor, WebTracerProvider } from "@opentelemetry/sdk-trace-web"
import { BrowserObservabilityConfig, otlpSignalUrl } from "./observability.config"

export function initializeOpenTelemetry(config: BrowserObservabilityConfig): void {
  if (!config.enabled) return

  const resource = new Resource({
    "service.name": config.serviceName,
    "service.namespace": config.serviceNamespace,
    "service.version": config.serviceVersion,
    "deployment.environment.name": config.deploymentEnvironment,
  })
  const traceProcessors = config.tracesExporter === "otlp" && config.exporterEndpoint
    ? [new BatchSpanProcessor(new OTLPTraceExporter({ url: otlpSignalUrl(config.exporterEndpoint, "traces") }))]
    : []
  const tracerProvider = new WebTracerProvider({ resource, spanProcessors: traceProcessors })
  tracerProvider.register({ contextManager: new ZoneContextManager(), propagator: new W3CTraceContextPropagator() })
  propagation.setGlobalPropagator(new W3CTraceContextPropagator())

  const readers = config.metricsExporter === "otlp" && config.exporterEndpoint
    ? [new PeriodicExportingMetricReader({ exporter: new OTLPMetricExporter({ url: otlpSignalUrl(config.exporterEndpoint, "metrics") }) })]
    : []
  const meterProvider = new MeterProvider({ resource, readers })
  metrics.setGlobalMeterProvider(meterProvider)

  const loggerProvider = new LoggerProvider({ resource })
  if (config.logsExporter === "otlp" && config.exporterEndpoint) {
    loggerProvider.addLogRecordProcessor(new BatchLogRecordProcessor(new OTLPLogExporter({ url: otlpSignalUrl(config.exporterEndpoint, "logs") })))
  }
  logs.setGlobalLoggerProvider(loggerProvider)

  window.addEventListener("pagehide", () => {
    void Promise.all([tracerProvider.forceFlush(), meterProvider.forceFlush(), loggerProvider.forceFlush()])
  })

  // Accessing context here ensures the Zone-based context manager is initialized before Angular bootstraps.
  context.active()
}
